/**
 * EventListeners : event listeners
 *
 * @author Nitesh <nitesh.meena@biz2credit.com>
 *
 */
const EventListeners = (function () {

    /**
     * addTransaction : adding new transaction row on table
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param defaultConfig object
     * @param trIndex number
     * @param iconsHTML string
     */
    const addTransaction = (transactionType, defaultConfig, trIndex, iconsHTML) => {
        const firstRow = initScript.getHTMLElementByDelimiter(defaultConfig.classNames.tbody + '_' + transactionType + '_tr_' + trIndex);
        const firstRowChildren = firstRow.children();
        /*for (let i = 0; i < firstRowChildren.length - 1; ++i) {
            firstRowChildren[i].innerHTML = firstRowChildren[i].children[0].value;
        }*/
        initScript.getHTMLElementObject(firstRowChildren[firstRowChildren.length - 1]).html(iconsHTML);
        toggleEditableHeaders(defaultConfig, transactionType, trIndex, false);
    };

    /**
     * toggleEditableHeaders : true/false toggle editable
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param defaultConfig object
     * @param transactionType string
     * @param trIndex number
     * @param flag boolean
     */
    const toggleEditableHeaders = (defaultConfig, transactionType, trIndex, flag) => {
        const headers = defaultConfig.expected.transactions.keys;
        for (let i = 0; i < headers.length; ++i) {
            toggleEditableTransaction(defaultConfig, transactionType, trIndex, i, headers[i], flag);
        }
    };

    /**
     * closeTransaction : removing table row
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param defaultConfig object
     * @param tableType string
     */
    const closeTransaction = (transactionType, defaultConfig, tableType = 'original') => {
        const trElement = initScript.getHTMLElementByDelimiter(tableType + '_' + defaultConfig.classNames.tbody).children()[0];
        trElement.remove();
    };

    const getSelectOptions = (flag = true) => {
        let option_2, option_1;
        if (flag === false) {
            option_1 = "debit";
            option_2 = "credit";
        } else {
            option_1 = "credit";
            option_2 = "debit";
        }
        let text = initScript.bindAttrsOnHTMLTag('option', option_1);
        text += initScript.bindAttrsOnHTMLTag('option', option_2);
        return initScript.bindAttrsOnHTMLTag('select', text);
    };

    /**
     * editTransaction : enabling editable transaction row
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param defaultConfig object
     * @param trIndex number
     */
    const editTransaction = (transactionType, defaultConfig, trIndex) => {
        initScript.getHTMLElementObject("td input").click(function() {
            $(this).focus();
        });
        initScript.getHTMLElementObject("td select").click(function() {
            $(this).focus();
        });
        const headers = defaultConfig.expected.transactions.keys;
        const tagClass = BankStatementAnalysis.getTDClass(transactionType, trIndex, '', -1, 'icons');
        initScript.changeIcons(defaultConfig, defaultConfig.onclick.changeIcons.edit, transactionType, trIndex, tagClass);

        for (let k = 0; k < headers.length; ++k) {
            const td_class = BankStatementAnalysis.getTDClass(transactionType, trIndex, headers[k], k), currentElement = initScript.getHTMLElementByDelimiter(td_class)[0];
            let html = "";
            if (headers[k] !== 'type') {
                html = "<input type='text' value='" + currentElement.textContent + "'>";
            }
            else {
                const td_select_element = initScript.getHTMLElementByDelimiter(td_class + " select")[0];
                html = currentElement.innerHTML;
                if (td_select_element.options[td_select_element.selectedIndex].value === "credit") html = getSelectOptions();
                else html = getSelectOptions(false);
                // currentElement.children[0].disabled = false;
                // initScript.getHTMLElementByDelimiter(td_class + " select")[0].disabled = true;
            }
            currentElement.innerHTML = html;
            // initScript.getHTMLElementByDelimiter(td_class + " select")[0].disabled = true;
            // toggleEditableTransaction(defaultConfig, transactionType, trIndex, k, headers[k], true);
            initScript.getHTMLElementObject(currentElement).attr('style', initScript.getStyleString(defaultConfig.table.edit.css));
        }
    };

    /**
     * defaultStyleAtRow : updating default style on table row
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param defaultConfig object
     * @param trIndex number
     */
    const defaultStyleAtRow = (transactionType, defaultConfig, trIndex) => {
        const headers = defaultConfig.expected.transactions.keys;
        for (let k = 0; k < headers.length; ++k) {
            const currentElement = initScript.getHTMLElementByDelimiter(BankStatementAnalysis.getTDClass(transactionType, trIndex, headers[k], k));
            initScript.getHTMLElementObject(currentElement).attr('style', initScript.getStyleString(defaultConfig.table.default.css));
        }
    };

    /**
     * defaultStyleAtRow : toggle editable transaction table row
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param defaultConfig object
     * @param transactionType string
     * @param indexI number
     * @param indexJ number
     * @param key string
     * @param flag boolean
     */
    const toggleEditableTransaction = (defaultConfig, transactionType, indexI, indexJ, key, flag = true) => {
        // const tr_element = initScript.getHTMLElementByDelimiter((defaultConfig.classNames.tbody + '_' + transactionType + '_tr_' + indexI))[0];
        const td_class = BankStatementAnalysis.getTDClass(transactionType, indexI, key, indexJ),
            td_element = initScript.getHTMLElementByDelimiter(td_class)[0], td_select_element = initScript.getHTMLElementByDelimiter(td_class + " select")[0],
            td_element_html = td_element.innerHTML;
        const td_child_html = initScript.getHTMLElementObject(td_element_html)[0], tag = td_child_html.tagName.toLowerCase();
        if (flag === false) {
            if (tag === "input") {
                td_element.innerHTML = td_child_html.value || td_element.children[0].value;
            } else {
                let tempHtml = "", option_2, option_1;
                if (td_select_element.options[td_select_element.selectedIndex].value === "debit") {
                    option_1 = "debit";
                    option_2 = "credit";
                } else {
                    option_1 = "credit";
                    option_2 = "debit";
                }
                let text = initScript.bindAttrsOnHTMLTag('option', option_1);
                text += initScript.bindAttrsOnHTMLTag('option', option_2);
                tempHtml = initScript.bindAttrsOnHTMLTag('select', text);
                // td_element.innerHTML = td_child_html.outerHTML;
                td_element.innerHTML = tempHtml;
                initScript.getHTMLElementByDelimiter(td_class + " select")[0].disabled = true;
            }
        }
    };

    /**
     * updateTransaction : updating table transaction row
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param transactionType string
     * @param defaultConfig object
     * @param trIndex number
     */
    const updateTransaction = (transactionType, defaultConfig, trIndex) => {
        const headers = defaultConfig.expected.transactions.keys;
        for (let k = 0; k < headers.length; ++k) {
            const updateElement = initScript.getHTMLElementByDelimiter(BankStatementAnalysis.getTDClass(transactionType, trIndex, headers[k], k));
            initScript.getHTMLElementObject(updateElement).attr('style', initScript.getStyleString(defaultConfig.table.delete.css));
        }
    };

    /**
     * deleteTransaction : deleting transaction
     *
     * @author Nitesh <nitesh.meena@biz2credit.com>
     *
     * @param headers array
     * @param transactionType string
     * @param defaultConfig object
     * @param trIndex number
     */
    const deleteTransaction = (headers, transactionType, defaultConfig, trIndex) => {
        for (let k = 0; k < headers.length; ++k) {
            const deleteElement = initScript.getHTMLElementByDelimiter(BankStatementAnalysis.getTDClass(transactionType, trIndex, headers[k], k));
            initScript.getHTMLElementObject(deleteElement).attr('style', initScript.getStyleString(defaultConfig.table.delete.css));
        }
    };
    return {
        addTransaction,
        editTransaction,
        updateTransaction,
        deleteTransaction,
        toggleEditableTransaction,
        closeTransaction,
        toggleEditableHeaders,
        defaultStyleAtRow
    };
})();
